"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var PREFIX = 'RadioSelect';
var classes = {
    radioLabel: "".concat(PREFIX, "-radioLabel"),
    selected: "".concat(PREFIX, "-selected"),
    root: "".concat(PREFIX, "-root"),
};
var StyledRadioGroup = (0, styles_1.styled)(material_1.RadioGroup)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.radioLabel)] = {
            padding: theme.spacing(0.5, 0),
            border: "1px solid ".concat(theme.palette.grey[400]),
            borderRadius: 8,
            margin: theme.spacing(1, 0),
            '&:hover': {
                backgroundColor: theme.palette.secondary.light,
                borderColor: theme.palette.secondary.main,
            },
        },
        _b[".".concat(classes.selected)] = {
            borderColor: theme.palette.secondary.main,
            '& .RadioSelect-root': {
                color: theme.palette.secondary.main,
            },
        },
        _b[".".concat(classes.root)] = {
            color: theme.palette.grey[400],
        },
        _b);
});
var RadioSelect = function (_a) {
    var _b = _a.input, onChange = _b.onChange, value = _b.value, options = _a.options, label = _a.label;
    return ((0, jsx_runtime_1.jsx)(StyledRadioGroup, __assign({ "aria-label": label }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { className: (0, clsx_1.default)(classes.radioLabel, value === option.value ? classes.selected : ''), value: option.value, checked: value === option.value, control: (0, jsx_runtime_1.jsx)(material_1.Radio, { checkedIcon: (0, jsx_runtime_1.jsx)(CheckCircle_1.default, {}), classes: { root: classes.root } }), label: option.label, onChange: function (e) { return e.currentTarget.checked && onChange(option.value); } }, option.value)); }) })));
};
exports.default = RadioSelect;
